import { RECT_PALETTE_SLOTS } from "../gl/rectRenderer";

const COLOR_SLOT_UP = 0;
const COLOR_SLOT_DOWN = 1;
const RGBA_COMPONENTS = 4;

/** @param {{ open: number, close: number }} bar */
export const isRisingBar = (bar) => bar.close >= bar.open;

/**
 * Palette slot of a bar: the up colour when it closed at or above its open.
 *
 * @param {{ open: number, close: number }} bar
 * @returns {number}
 */
export const colorSlotOf = (bar) => (isRisingBar(bar) ? COLOR_SLOT_UP : COLOR_SLOT_DOWN);

/**
 * @param {number[]} upColor - RGBA 0..1
 * @param {number[]} downColor - RGBA 0..1
 * @returns {Float32Array} RECT_PALETTE_SLOTS colours
 */
export const buildSeriesPalette = (upColor, downColor) => {
  const palette = new Float32Array(RECT_PALETTE_SLOTS * RGBA_COMPONENTS);

  palette.set(upColor, COLOR_SLOT_UP * RGBA_COMPONENTS);
  palette.set(downColor, COLOR_SLOT_DOWN * RGBA_COMPONENTS);

  return palette;
};
